var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTxnRequestSent = function SvgTxnRequestSent(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#9fa9ff;}.cls-3{fill:#4c65ba;}.cls-4{fill:#cb7a63;}.cls-5{fill:#5e80e6;}.cls-6{fill:#263238;}.cls-11,.cls-15,.cls-7{isolation:isolate;}.cls-11,.cls-16,.cls-17,.cls-22,.cls-7{opacity:0.2;}.cls-8{fill:#407bff;}.cls-14,.cls-15,.cls-19,.cls-23,.cls-9{fill:#fff;}.cls-20,.cls-25,.cls-9{opacity:0.5;}.cls-10{fill:#ffc3d0;}.cls-12{fill:#a02724;}.cls-13,.cls-25{fill:#022;}.cls-14{opacity:0.9;}.cls-15{opacity:0.1;}.cls-16{fill:#e6e6e6;}.cls-18,.cls-23{opacity:0.7;}.cls-21{fill:#636ff0;}.cls-24{fill:#e5e8f6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "234.07 257 236.57 242.58 241.48 244 234.07 257"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.72 261.62 249.78 257.55 247.82 252.82 235.72 261.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "238.22 256.19 246.23 241.05 251.63 244.8 238.22 256.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.89,278.91H99.56a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.33a.51.51,0,0,1,.5.5A.5.5,0,0,1,105.89,278.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.35,278.91H63.62a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H95.35a.51.51,0,0,1,.5.5A.5.5,0,0,1,95.35,278.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.85,336.78a.55.55,0,0,1-.34-.13.5.5,0,0,1,0-.71l3-3.22a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-3,3.22A.52.52,0,0,1,207.85,336.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.74,362.41a.48.48,0,0,1-.44-.28.49.49,0,0,1,.22-.67c9.26-4.69,23.95-22.23,24.1-22.41a.49.49,0,0,1,.7-.06.51.51,0,0,1,.06.71c-.6.72-15,17.87-24.41,22.65A.46.46,0,0,1,180.74,362.41Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "252.71 356.93 259.84 351.02 241.86 333.96 234.19 340.51 252.71 356.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.62,348.74a3.82,3.82,0,0,0-2.47.12c-.48.14-1,.31-1.42.47s-.67.26-.94.37l-.79.35a.21.21,0,0,0-.16.21.13.13,0,0,0,0,.1.24.24,0,0,0,.14.1,18,18,0,0,0,3.09.53,3.75,3.75,0,0,0,1.53-.12h.07a4.3,4.3,0,0,0,.82-.37,1.27,1.27,0,0,0,.47-1.11A.77.77,0,0,0,265.62,348.74Zm-.1.66a.76.76,0,0,1-.31.75,1.78,1.78,0,0,1-.81.32,5.07,5.07,0,0,1-1.22.07,13.68,13.68,0,0,1-1.9-.24l-.47-.09a12.81,12.81,0,0,1,2.67-.93A11.71,11.71,0,0,1,265,349a.77.77,0,0,1,.42.1A.28.28,0,0,1,265.52,349.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.35,345a1.72,1.72,0,0,0-1.13.74,2.32,2.32,0,0,0-.21.38,7.15,7.15,0,0,0-.22,3.6.11.11,0,0,1,0,.05.23.23,0,0,0,.15.17.17.17,0,0,0,.14,0,.11.11,0,0,0,.09-.05,4.73,4.73,0,0,0,.55-.55,8.77,8.77,0,0,0,.85-1.2c.62-1,1.06-2.15.79-2.74C263.26,345.14,263,344.88,262.35,345Zm.6.6c.17.38-.17,1.28-.67,2.16a8.51,8.51,0,0,1-1.08,1.5,6.78,6.78,0,0,1,.14-2.72,1.93,1.93,0,0,1,.26-.54,1.3,1.3,0,0,1,.69-.51l.14,0C262.85,345.37,262.93,345.53,263,345.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.91,350.6l-9,4.52a.79.79,0,0,0-.42.94l2.64,8.38a1.58,1.58,0,0,0,2,1l.15-.07c15.35-5.39,20.06-9.21,21.66-10.08,4.57-2.49,2-5.73.3-5.33-7.66,1.83-10.23,1.36-13.54.51A7.94,7.94,0,0,0,258.91,350.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "241.87 333.97 250.97 342.04 243.29 348.58 234.19 340.51 241.87 333.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "239.03 348.52 250.48 337.96 247.96 333.54 234.72 344.91 239.03 348.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "239.03 348.52 250.48 337.96 247.96 333.54 234.72 344.91 239.03 348.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.16,335.09l-1.54,1.32-2.29,2L241,339.54,237,343l-.77.65s-16.31-9.19-25.39-17c-6.21-5.37-6.77-7.38-7.43-6.88-8.77,6.68-34.73,29.74-49.44,41.73-.48.06-1,.1-1.44.14-7.86.57-14-.29-18.84-2.12,0-6.38,5.41-21.28,5.86-22.72,0,0,21.71-21.57,56.89-39.81a11,11,0,0,1,1.06-.47,14.77,14.77,0,0,1,1.38-.56,17.73,17.73,0,0,1,5.39-1.22,11.84,11.84,0,0,1,4.57.72,17.6,17.6,0,0,1,2.44,1.08,20.75,20.75,0,0,1,2,1.18c1.09.69,2.14,1.46,3.13,2.22,2.25,1.74,19.24,23.63,28.37,33.73h0C245.27,334.14,245.73,334.64,246.16,335.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.31,243c1.38,6.22,2.82,15.31-1.46,19.59a139.38,139.38,0,0,0,19,25.9c9.37-16.29.49-26.36.49-26.36-7-1.5-6.91-4.33-5.81-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M124.51,263.35a7.9,7.9,0,0,1,3-4.16c1.41-1.07,16-1.23,19.75,0a9.54,9.54,0,0,1,5.29,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.68,288.15l3.76-1.72.19,6.14a11.58,11.58,0,0,1-3.69,2.17,2.51,2.51,0,0,1-3.15-3h0A5.38,5.38,0,0,1,191.68,288.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.26,288.16l-.2,2.26a1.6,1.6,0,0,1-1.24,1.43l-3.22.72-.19-6.14,3.27.05a1.55,1.55,0,0,1,1.58,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.87,305.61a32.37,32.37,0,0,0,19.41,3.25c8-1.35,22-9.4,28.07-14l-2-3c-3,.65-27.79,13.23-43.78,1.85-3-2.12-14.69-10.85-18.82-10.67-6.71.3-6.13,7.33-3.25,10.26C126.83,296.65,139.24,303.33,143.87,305.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.06,290.42a1.57,1.57,0,0,1-1.23,1.42l-3.2.73h0a11.58,11.58,0,0,1-3.69,2.17,2,2,0,0,1-.59.1h0c-6.08,4.62-20,12.66-28.06,14a32.41,32.41,0,0,1-19.4-3.25c-4.63-2.28-17.06-9-20.43-12.38-2.88-2.93-3.46-10,3.25-10.26,4.13-.18,15.83,8.55,18.82,10.67,15.26,10.85,38.48-.09,43.23-1.69a1.7,1.7,0,0,1,0-.22,5.39,5.39,0,0,1,1-2.12,5.31,5.31,0,0,1,1.85-1.46l3.73-1.71h0l3.25.05a1.55,1.55,0,0,1,1.57,1.55v.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.44 286.43 195.41 286.44 195.41 286.43 195.44 286.43"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.84,273.4c8.49,18.71-11.2,24.06-2.18,54.74l-42.8,1c.28-16.44,6.13-12.91-1.58-43.82-.65-2.62-1.73-10.13,1.06-17a12.45,12.45,0,0,1,5.55-6.29c3.16-1.7,17.08-.37,23.43.06C155.2,261.16,163.58,271.06,164.84,273.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M164.84,273.4c8.49,18.71-11.2,24.06-2.18,54.74l-42.8,1c.28-16.44,6.13-12.91-1.58-43.82-.65-2.62-1.73-10.13,1.06-17a12.45,12.45,0,0,1,5.55-6.29c3.16-1.7,17.08-.37,23.43.06C155.2,261.16,163.58,271.06,164.84,273.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.66,236.28c-.12.82.21,1.49.72,1.56s1-.5,1.15-1.29-.22-1.48-.73-1.56S156.77,235.5,156.66,236.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.57,235l2-.27S158.35,236.07,157.57,235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.79,237.36a20.74,20.74,0,0,0,2.08,5.41,3.41,3.41,0,0,1-2.88.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.49,230.78a.45.45,0,0,0,.29-.36.48.48,0,0,0-.39-.54,4.62,4.62,0,0,0-4.06,1.28.47.47,0,1,0,.63.69l.06-.07a3.73,3.73,0,0,1,3.23-1A.48.48,0,0,0,159.49,230.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.76,229.8c-.81,9.75-1.36,13.86,2.79,19.53,6.26,8.52,18.43,7.4,22.11-1.91,3.35-8.39,4.11-22.92-4.78-28.13A13.34,13.34,0,0,0,132.59,224,13.2,13.2,0,0,0,130.76,229.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.89,246.83a5.51,5.51,0,0,1-1.62-2.39.23.23,0,0,1,.14-.25.2.2,0,0,1,.24.14,5.44,5.44,0,0,0,1.39,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.51,220.28c-3.72,5,4.34,2.74-1.79,12.88-3,4.88,7.51,16.25,10.12,16.9,4.68,1.18,9.23-2.1,12.74-5.41a35.71,35.71,0,0,0,7.9-9.82c1.88-3.79,2.57-8.34,1-12.27-1.68-4.27-7.61-8.08-12.05-9C137.23,212.44,127.6,216.09,124.51,220.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153,235.66s1.17,2-.31,3.51l0-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153,235.66s.43,3.08-2.15,4.23l1.38-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.78,248.93s-2.84,1.29-2.43,4.08l2.07-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.89,249s-2.16,2.24-.74,4.69l.83-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.86,231.63a18.54,18.54,0,0,0,2.78-3.35,6.28,6.28,0,0,0,1-4.16,6.42,6.42,0,0,0-3.32-4.33A18.6,18.6,0,0,0,152,218a3.69,3.69,0,0,0-2.7.08,2.51,2.51,0,0,0-1,2.32,8,8,0,0,0,.72,2.56,52.75,52.75,0,0,1,2.68,10c.31,1.72.08,2.87,1.78,2.2C154.53,234.77,156,232.54,156.86,231.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.4,236.45a8.53,8.53,0,0,0,2.21,6.13c2,2.2,4.62.76,5.36-2,.67-2.46.42-6.57-2.25-7.75S143.54,233.7,143.4,236.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "256.82 361.42 264.54 353.9 249.59 335.11 240.26 340.62 256.82 361.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.42,351.58c-.85-.3-2.61.66-3.95,1.51-.34.21-.64.42-.9.6h0l-.13.1c-.3.21-.52.37-.6.44a.22.22,0,0,0-.12.25.25.25,0,0,0,.23.18,18.23,18.23,0,0,0,2.76-.09l.61-.07a3.84,3.84,0,0,0,1.85-.64,3.33,3.33,0,0,0,.56-.43,1.35,1.35,0,0,0,.25-1.27A.88.88,0,0,0,272.42,351.58Zm.06.72a.88.88,0,0,1-.17.86,2.83,2.83,0,0,1-1.52.76,11,11,0,0,1-2.06.27q-.48,0-1,0l.34-.25a1.77,1.77,0,0,1,.24-.17,13,13,0,0,1,3.51-1.75.84.84,0,0,1,.47,0A.32.32,0,0,1,272.48,352.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.14,348.39a1.74,1.74,0,0,0-1,1c-.64,1.53.3,3.91.45,4.28h0a0,0,0,0,0,0,0,.25.25,0,0,0,.2.15.38.38,0,0,0,.15,0,.14.14,0,0,0,.08-.07l0,0a5.05,5.05,0,0,0,.42-.68c.74-1.39,1.43-3.71.83-4.51C269.12,348.34,268.79,348.12,268.14,348.39Zm-.25,4.72a5.79,5.79,0,0,1-.32-3.51,1.34,1.34,0,0,1,.62-.69l.13-.06c.43-.17.54,0,.58,0C269.34,349.46,268.67,351.83,267.89,353.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "248.81 333.96 255.84 342.96 246.33 348.27 239.19 339.5 248.81 333.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M119.47,325.89l-1,3.89c-.15.3.22.59.71.58l44.07-1c.39,0,.7-.21.72-.46l-1.1-4.07c0-.26-.32-.48-.74-.47l-42,1.24A.81.81,0,0,0,119.47,325.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.69,329.78l-1.16.13c-.23,0-.42-.07-.42-.22l0-5c0-.15.19-.29.41-.31l1.16-.14c.23,0,.42.08.42.23l0,5C159.1,329.62,158.92,329.76,158.69,329.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.91,330l-1.16.12c-.22,0-.41-.07-.41-.22l0-5c0-.14.19-.28.42-.31l1.15-.13c.23,0,.42.07.42.22l0,5C143.33,329.84,143.14,330,142.91,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.91,330l-1.16.12c-.22,0-.41-.07-.41-.22l0-5c0-.14.19-.28.42-.31l1.15-.13c.23,0,.42.07.42.22l0,5C143.33,329.84,143.14,330,142.91,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.72,338l-1.95,1.1h0L249.41,341l-3,1.69h0l-3.09,1.74h0l-1.19.67-.74-.55c-.18-.12-.39-.27-.63-.46-.74-.55-1.76-1.31-3-2.26h0c-6.21-4.92-17.28-14.58-20.58-23.37-2.13,2.54-4.68,5.73-7.6,9.25C197,342.88,177.48,364.29,154,367.08l-1.44.15c-7.85.67-14-.11-18.85-1.88-12.19-4.47-15.59-15.18-14.76-24.29v0c.08-4.27.91-11.87.91-11.87l44.48,0c6.26-7.61,18.84-19.53,31.69-27,.3-.19.61-.37.92-.53s.77-.44,1.15-.65a51.81,51.81,0,0,1,12.33-5c.88-.21,1.75-.39,2.61-.52a24.37,24.37,0,0,1,2.66-.25h0c6.09-.27,11.38,2,15,8.07L254.05,337Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monitor_Screen",
    "data-name": "Monitor Screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "230.72 291.78 181.58 293.81 183.02 262.54 232.16 260.51 230.72 291.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.15,294.24l-48.43,2a2.23,2.23,0,0,1-2.37-2.39l1.42-31.07a2.78,2.78,0,0,1,2.61-2.6l48.43-2a2.24,2.24,0,0,1,2.37,2.39l-1.43,31.07A2.76,2.76,0,0,1,230.15,294.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "230.72 291.78 181.58 293.81 183.02 262.54 232.16 260.51 230.72 291.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "230.72 291.78 181.58 293.81 183.02 262.54 232.16 260.51 230.72 291.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "200.46 259.49 192.34 295.79 195.57 295.66 203.58 259.36 200.46 259.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "205.44 259.28 197.32 295.58 203.73 295.32 211.74 259.02 205.44 259.28"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.77,294.63l16.36-.46c.28,1.9-.53,2.61-1.57,2.64l-5.23.13-3.5.08-5.43.15-33.69,1-.27-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.77,294.63l16.36-.46c.28,1.9-.53,2.61-1.57,2.64l-5.23.13-3.5.08-5.43.15-41.7,1.28a1.2,1.2,0,0,1-1.13-.68h0a1.21,1.21,0,0,1,1.05-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M214.77,294.63l16.36-.46c.28,1.9-.53,2.61-1.57,2.64l-5.23.13-3.5.08-5.43.15-41.7,1.28a1.2,1.2,0,0,1-1.13-.68h0a1.21,1.21,0,0,1,1.05-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M231.13,294.17l.1.66a1.73,1.73,0,0,1-1.67,2l-5.23.13-9.72.35.16-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.39,274.32s-2.31,4.71,4.36,17.15l2.79,5.07h0c.92,1.67,7-1.74,8.86-4.87h0S150.7,284.65,146.39,274.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203,288.82l4.65-1.37-.74,7.18s-6.49,4.34-8.74.19l.91-2.31A6.22,6.22,0,0,1,203,288.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213,290.27l-.58,2.59a1.86,1.86,0,0,1-1.67,1.46l-3.87.31.75-7.19,3.8.6a1.86,1.86,0,0,1,1.6,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.24,301c3.25,4.4,7.81,8.08,13.17,9.13,6.32,1.23,18.48-7.71,24.18-13.49-.28-2.44-.12-3.76-2.55-4.1,0,0-6.28,4.6-18.11,7.36-3.83.89-6.38-3-9.71-8.71-1.66-2.83-7-14.47-9.07-17.06-3.26-4.16-12.52-1.18-8.84,8.83C154.85,287.14,161.59,297.38,164.24,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M160.78,267.29c6.57,6,9.77,16.72,9.77,16.72l-15.35,9.36S144,277.61,146,272.12c1.58-4.26,4.51-7.06,8.36-7.3A8.82,8.82,0,0,1,160.78,267.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.56,330.59l-1.16,0c-.23,0-.42-.11-.4-.26l.43-5c0-.15.21-.27.44-.28l1.16,0c.23,0,.42.12.4.26l-.43,5A.38.38,0,0,1,125.56,330.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "240.23 347.23 255.19 339.75 253.91 334.43 236.85 342.21 240.23 347.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "240.23 347.23 255.19 339.75 253.91 334.43 236.85 342.21 240.23 347.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.94,353.08l-10.32,3.12a.85.85,0,0,0-.62.92l1.25,9.36a1.68,1.68,0,0,0,1.95,1.39l.18,0c17.24-2.87,22.93-6,24.78-6.66,5.3-1.79,3.18-5.69,1.3-5.58-8.44.52-11.07-.46-14.42-2A8.45,8.45,0,0,0,263.94,353.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.72,224.87c-5,1.18-13.73,8.49-6.9,17.71,5.24,7.07,4.8,16.74-2,22.56-6.38,5.45-12.1,12.33-20.19,8.17-14.77-7.61,9.06-21.43,2.23-33.59-5.35-9.52,10.6-22.86,16.3-25.18,2.14-.87,11.56-2,14.41,3.28C135.22,228.45,125.72,224.87,125.72,224.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "230.28 271.23 200.03 272.51 200.17 269.51 230.42 268.23 230.28 271.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "230.28 271.23 200.03 272.51 200.17 269.51 230.42 268.23 230.28 271.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "230.1 275.39 199.85 276.68 199.98 273.68 230.23 272.39 230.1 275.39"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "230.1 275.39 199.85 276.68 199.98 273.68 230.23 272.39 230.1 275.39"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "229.91 279.56 199.66 280.85 199.8 277.84 230.04 276.56 229.91 279.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "229.91 279.56 199.66 280.85 199.8 277.84 230.04 276.56 229.91 279.56"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "229.72 283.72 199.47 285.01 199.61 282.01 229.86 280.72 229.72 283.72"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "229.72 283.72 199.47 285.01 199.61 282.01 229.86 280.72 229.72 283.72"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "229.54 287.89 199.29 289.18 199.42 286.18 229.67 284.89 229.54 287.89"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "229.54 287.89 199.29 289.18 199.42 286.18 229.67 284.89 229.54 287.89"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.4,
    y: 274.25,
    width: 2.43,
    height: 1,
    transform: "translate(-11.63 8.27) rotate(-2.46)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 185.4,
    y: 274.25,
    width: 2.43,
    height: 1,
    transform: "translate(-11.63 8.27) rotate(-2.46)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.29,
    y: 277.14,
    width: 2.43,
    height: 1,
    transform: "translate(-11.76 8.27) rotate(-2.46)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 185.29,
    y: 277.14,
    width: 2.43,
    height: 1,
    transform: "translate(-11.76 8.27) rotate(-2.46)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.17,
    y: 280.02,
    width: 2.43,
    height: 1,
    transform: "matrix(1, -0.04, 0.04, 1, -11.85, 8.25)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 185.17,
    y: 280.02,
    width: 2.43,
    height: 1,
    transform: "matrix(1, -0.04, 0.04, 1, -11.85, 8.25)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.06,
    y: 282.91,
    width: 2.43,
    height: 1,
    transform: "translate(-12 8.26) rotate(-2.46)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 185.06,
    y: 282.91,
    width: 2.43,
    height: 1,
    transform: "translate(-12 8.26) rotate(-2.46)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 184.94,
    y: 285.79,
    width: 2.43,
    height: 1,
    transform: "matrix(1, -0.04, 0.04, 1, -12.1, 8.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "184.97 286.84 185.06 285.84 187.48 285.73 187.39 286.74 184.97 286.84"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 184.83,
    y: 288.68,
    width: 2.43,
    height: 1,
    transform: "translate(-12 8.08) rotate(-2.41)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 184.83,
    y: 288.68,
    width: 2.43,
    height: 1,
    transform: "translate(-12 8.08) rotate(-2.41)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.34 271.44 185.32 273.31 185.37 271.99 188.15 271.54 185.4 271.35 185.45 270.03 190.34 271.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "220.99 266.67 200.03 267.56 200.13 265.48 221.09 264.59 220.99 266.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.99 266.67 200.03 267.56 200.13 265.48 221.09 264.59 220.99 266.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "192.71 267.74 189.64 267.88 190.88 267.09 191.22 267.4 191.59 267.08 192.71 267.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.76 266.99 189.52 267.79 189.61 265.95 190.76 266.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "192.91 265.9 192.81 267.63 191.68 266.97 192.91 265.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 191.18,
    y: 266.7,
    width: 0.1,
    height: 0.01,
    transform: "translate(-133.95 222.4) rotate(-46.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 191.23,
    y: 266.66,
    width: 0.01,
    height: 0.1,
    transform: "translate(-131.02 204.61) rotate(-43.45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "192.91 265.72 191.59 266.92 191.22 267.25 190.88 266.93 189.73 265.89 189.64 265.81 192.91 265.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.4,
    y: 266.11,
    width: 2.43,
    height: 0.3,
    transform: "translate(-11.14 8.16) rotate(-2.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.4,
    y: 266.87,
    width: 2.43,
    height: 0.3,
    transform: "translate(-11.17 8.16) rotate(-2.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.4,
    y: 267.64,
    width: 2.43,
    height: 0.3,
    transform: "translate(-11.2 8.17) rotate(-2.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.22,216.18s2.11,9.86-3.71,8.93a1.59,1.59,0,0,0,1.25,1.51c1.73.62,5.13-4,3.73-10.75C129.49,215.87,128.83,215.09,128.22,216.18Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Files"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.71,115.68H314.14a2.4,2.4,0,0,1,0-4.79h14.57a2.4,2.4,0,0,1,0,4.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M328.71,115.68H314.14a2.4,2.4,0,0,1,0-4.79h14.57a2.4,2.4,0,0,1,0,4.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M382.16,164.79,326.3,267.59a2.73,2.73,0,0,1-3.7,1.09L227.55,217a2.73,2.73,0,0,1-1.09-3.7L299.11,79.62a2.73,2.73,0,0,1,3.7-1.09l64,34.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.16,164.79,326.3,267.59a2.73,2.73,0,0,1-3.7,1.09L227.55,217a2.73,2.73,0,0,1-1.09-3.7L299.11,79.62a2.73,2.73,0,0,1,3.7-1.09l64,34.8Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 273.81,
    y: 168.41,
    width: 80.66,
    height: 5,
    transform: "translate(118.81 -128.66) rotate(28.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 264.11,
    y: 186.39,
    width: 80.66,
    height: 5,
    transform: "translate(126.19 -121.9) rotate(28.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 254.41,
    y: 204.37,
    width: 80.66,
    height: 5,
    transform: "translate(133.56 -115.13) rotate(28.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366.94,113.28l-16.84,31a2.73,2.73,0,0,0,1.09,3.7l30.91,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M366.94,113.28l-16.84,31a2.73,2.73,0,0,0,1.09,3.7l30.91,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M396.72,161.33l-55.85,102.8a2.73,2.73,0,0,1-3.7,1.09l-95.05-51.64a2.73,2.73,0,0,1-1.1-3.7L313.67,76.17a2.73,2.73,0,0,1,3.7-1.1l64.05,34.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M396.72,161.33l-55.85,102.8a2.73,2.73,0,0,1-3.7,1.09l-95.05-51.64a2.73,2.73,0,0,1-1.1-3.7L313.67,76.17a2.73,2.73,0,0,1,3.7-1.1l64.05,34.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.49,183.38l-67.2-36.25a2.14,2.14,0,0,0-2.91.87l-.33.61a2.15,2.15,0,0,0,.87,2.92l67.2,36.25a2.15,2.15,0,0,0,2.91-.87l.33-.62A2.14,2.14,0,0,0,363.49,183.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 278.68,
    y: 182.93,
    width: 80.66,
    height: 5,
    rx: 2.15,
    transform: "translate(126.29 -129.23) rotate(28.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 268.98,
    y: 200.92,
    width: 80.66,
    height: 5,
    rx: 2.15,
    transform: "translate(133.67 -122.46) rotate(28.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M381.51,109.83l-16.85,31a2.71,2.71,0,0,0,1.1,3.69l30.91,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M381.51,109.83l-16.85,31a2.71,2.71,0,0,0,1.1,3.69l30.91,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M377.65,62.7l4.7,20.87c-17.8,4.88-33.77,22.5-45.26,39.14A96.21,96.21,0,0,0,325.84,145s35.9-32.47,55.69-34.37l-.95,34.49s20.53-40,60.38-54.6C441,90.51,407.58,66.47,377.65,62.7Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Couch"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.51,290.7l9.07,103.68H130l-9.76-111.57h6.7A8.64,8.64,0,0,1,135.51,290.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M135.6,291.64l9,102.74H130l-9.76-111.57H126A9.68,9.68,0,0,1,135.6,291.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M126,289.57l9.17,104.81h-87l-9-103.52a7.4,7.4,0,0,1,7.37-8.05h72.18A7.4,7.4,0,0,1,126,289.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M279.19,394.38H48.54L46,365.63h221.4a10.3,10.3,0,0,1,10.06,9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.77,405.39H45.83a5.74,5.74,0,0,1-5.73-5.73h0a5.73,5.73,0,0,1,5.73-5.73H289.77a5.73,5.73,0,0,1,5.73,5.73h0A5.74,5.74,0,0,1,289.77,405.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M289.77,405.39H148.16a5.73,5.73,0,0,1-5.73-5.73h0a5.72,5.72,0,0,1,5.73-5.73H289.77a5.73,5.73,0,0,1,5.73,5.73h0A5.74,5.74,0,0,1,289.77,405.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.03 405.39 51.92 415.22 57.7 415.22 60.88 405.39 49.03 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "49.03 405.39 51.92 415.22 57.7 415.22 60.88 405.39 49.03 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "131.86 405.39 134.75 415.22 140.53 415.22 143.72 405.39 131.86 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "131.86 405.39 134.75 415.22 140.53 415.22 143.72 405.39 131.86 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "195.26 405.39 198.15 415.22 203.93 415.22 207.11 405.39 195.26 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "195.26 405.39 198.15 415.22 203.93 415.22 207.11 405.39 195.26 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "278.09 405.39 280.98 415.22 286.76 415.22 289.94 405.39 278.09 405.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "278.09 405.39 280.98 415.22 286.76 415.22 289.94 405.39 278.09 405.39"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxnRequestSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Txn_Request_Sent.012af7fe.svg";
export { ForwardRef as ReactComponent };